import { defineMessages } from 'react-intl';

type MessageKeys = 'confirmActionButton' | 'cancelActionButton' | 'erroredActionButton';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		confirmActionButton: {
			id: 'ai-mate.chat-history.store-assistant.message-actions.confirm-button',
			defaultMessage: 'Confirm',
			description:
				'Button label displayed on the confirm button in an action card within the AI conversation interface that confirms and executes an AI-suggested action. Shown as the text on a button. When clicked, it confirms the action and triggers its execution (such as creating a work item, posting a comment, etc.). The purpose is to provide a clear way for users to approve and execute AI-suggested actions.',
		},
		cancelActionButton: {
			id: 'ai-mate.chat-history.store-assistant.message-actions.cancel-button',
			defaultMessage: 'Cancel',
			description:
				'Button label displayed on the cancel button in an action card within the AI conversation interface that cancels an AI-suggested action. Shown as the text on a button. When clicked, it cancels the action and discards any changes or suggestions. The purpose is to provide users with a way to reject the AI-suggested action without executing it.',
		},
		erroredActionButton: {
			id: 'ai-mate.chat-history.store-assistant.message-actions.errored-button',
			defaultMessage: 'There was an issue completing this action',
			description:
				'Error message text displayed on a button or in an action card within the AI conversation interface when an action execution has failed. Shown as the text on a disabled button or as an error message. The purpose is to inform the user that the action encountered an error and could not be completed, indicating that there was a problem with the execution.',
		},
	});

export default message;
